import Heading from "components/Heading/Heading";
import { Button, Form, Modal, message } from "antd";
import { useState } from "react";
import DataTable from "../../../components/Tables/DataTable";
import FormModal from "./FormModal";
import {
  useAddVendorMutation,
  useDeleteVendorMutation,
  useGetVendorsQuery,
  useUpdateVendorMutation,
} from "../../../redux/Service/vendorsApi";
import dayjs from "dayjs";
import { useGetAccountsQuery } from "../../../redux/Service/Accounts";
import { useGetCurrenciesQuery } from "../../../redux/Service/currenciesApi";

function IndexSupplierCodes() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const {
    data: vendorsData,
    isLoading,
    isError,
  } = useGetVendorsQuery(undefined);

  const vendors = vendorsData?.ResponseObject ?? [];

  const {
    data: accountsData,
    isLoading: isAccountsLoading,
    isError: isAccountsError,
  } = useGetAccountsQuery(undefined);

  const accounts = accountsData?.ResponseObject ?? [];

  const {
    data: currenciesData,
    isLoading: isCurrenciesLoading,
    isError: isCurrenciesError,
  } = useGetCurrenciesQuery(undefined);

  const currencies = currenciesData?.ResponseObject ?? [];

  const [deleteVendor, { isLoading: isDeleting }] = useDeleteVendorMutation();
  const [addVendor, { isLoading: isAdding }] = useAddVendorMutation();
  const [updateVendor, { isLoading: isUpdating }] = useUpdateVendorMutation();

  const handleDeleteClick = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف المورد "${record.VendorName}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteVendor(record.VendorID).unwrap();
          if (response?.ResponseObject == true) {
            message.success("تم حذف المورد بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch (error) {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const columns: any = [
    { title: "كود المورد", dataIndex: "VendorID", key: "VendorID" },
    { title: "اسم المورد", dataIndex: "VendorName", key: "VendorName" },
    { title: "العنوان", dataIndex: "Address", key: "Address" },
    { title: "رقم الهاتف", dataIndex: "Phone", width: 120, key: "Phone" },
    { title: "رقم الموبايل", dataIndex: "Mobail", width: 120, key: "Mobail" },
    { title: "الرصيد الافتتاحي", dataIndex: "FirstBal", key: "FirstBal" },
    {
      title: "تاريخ الرصيد الافتتاحي",
      dataIndex: "FirstBalDate",
      key: "FirstBalDate",
      render: (date: string) => dayjs(date).format("YYYY-MM-DD"),
    },
  ];

  const handleOk = async (values) => {
    const body = {
      ...values,
      FirstBalDate: values.FirstBalDate?.format("YYYY-MM-DD"),
    };

    try {
      let response;
      if (isEditing) {
        response = await updateVendor(body).unwrap();
      } else {
        response = await addVendor(body).unwrap();
      }

      if (response?.ResponseObject == true) {
        message.success(
          isEditing ? "تم تعديل المورد بنجاح" : "تمت إضافة المورد بنجاح"
        );
        setIsModalOpen(false);
        form.resetFields();
        setIsEditing(false);
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setIsEditing(false);
  };

  const handleEditClick = (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);
    const recordData = { ...record };
    if (recordData.FirstBalDate) {
      recordData.FirstBalDate = dayjs(recordData.FirstBalDate);
    }
    form.setFieldsValue(recordData);
  };

  return (
    <>
      <Heading name={"الموردين"} />
      <div className="flex flex-wrap gap-4 relative">
        <div className="grid justify-start">
          <Button type="primary" onClick={() => setIsModalOpen(true)}>
            إضافه
          </Button>
        </div>

        <FormModal
          form={form}
          isEditing={isEditing}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          initialValues={{ FirstBal: 0, FirstBalDate: dayjs(new Date()) }}
          loading={isUpdating || isAdding}
          accounts={accounts}
          currencies={currencies}
        />

        <DataTable
          columns={columns}
          data={vendors}
          handleEditClick={handleEditClick}
          handleDeletClick={handleDeleteClick}
          isLoading={isLoading || isDeleting}
        />
      </div>
    </>
  );
}

export default IndexSupplierCodes;
